<template>
  <div style="text-align: center" v-if="calendarMini">
    <table style="width: 100%" cell-spacing="0">
      <tr>
        <td class="calendarCell">
          <CalendarLink :date="calendarMini.yearRange.start"
            >&lt;&lt;</CalendarLink
          >
        </td>
        <td colspan="5" class="calendarCell">{{ formatDate("yyyy") }}</td>
        <td class="calendarCell">
          <CalendarLink :date="calendarMini.yearRange.end"
            >&gt;&gt;</CalendarLink
          >
        </td>
      </tr>
      <tr>
        <td class="calendarCell">
          <CalendarLink :date="calendarMini.monthRange.start"
            >&lt;&lt;</CalendarLink
          >
        </td>
        <td colspan="5" class="calendarCell">{{ formatDate("MMM") }}</td>
        <td class="calendarCell">
          <CalendarLink :date="calendarMini.monthRange.end"
            >&gt;&gt;</CalendarLink
          >
        </td>
      </tr>
      <tr>
        <td class="calendarCell">
          <CalendarLink :date="calendarMini.dayRange.start"
            >&lt;&lt;</CalendarLink
          >
        </td>
        <td colspan="5" class="calendarCell">{{ formatDate("d") }}</td>
        <td class="calendarCell">
          <CalendarLink :date="calendarMini.dayRange.end"
            >&gt;&gt;</CalendarLink
          >
        </td>
      </tr>
      <tr>
        <td class="calendarHeader">M</td>
        <td class="calendarHeader">T</td>
        <td class="calendarHeader">W</td>
        <td class="calendarHeader">T</td>
        <td class="calendarHeader">F</td>
        <td class="calendarHeader">S</td>
        <td class="calendarHeader">S</td>
      </tr>
      <tr v-for="(week, windex) in calendarMini.weeks" :key="windex">
        <td
          :class="`calendarCell planner${day.styleClass}`"
          v-for="(day, dindex) in week.days"
          :key="dindex"
        >
          <CalendarLink :date="day.date">{{ day.dayOfMonth }}</CalendarLink>
        </td>
      </tr>
      <tr>
        <td class="calendarCell">
          <CalendarLink :date="calendarMini.weekRange.start"
            >&lt;&lt;</CalendarLink
          >
        </td>
        <td colspan="5" class="calendarCell">week {{ formatDate("w") }}</td>
        <td class="calendarCell">
          <CalendarLink :date="calendarMini.weekRange.end"
            >&gt;&gt;</CalendarLink
          >
        </td>
      </tr>
      <tr>
        <td colspan="7" class="calendarCell">
          <CalendarLink :date="today">today</CalendarLink>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { format, formatISO, parseISO } from "date-fns";
import CalendarLink from "@/components/layout/rightbar/CalendarLink";
import { getCalendarMini } from "@/util/helpers";
export default {
  name: "Calendar",
  components: {
    CalendarLink
  },
  data() {
    return {
      calendarMini: null,
      outcome: null,
      selected: null,
      today: null
    };
  },
  methods: {
    formatDate(f) {
      // console.log(this.calendarMini.date)
      return format(parseISO(this.calendarMini.date), f);
    },
    fetchCalendar() {
      const routes = [
        "billDiary",
        "completions",
        "diary",
        "diaryNew",
        "documentDiary",
        "emailDiary",
        "emailOffers",
        "eventsByDate",
        "instructions",
        "paymentsDiary",
        "receiptsDiary",
        "uploads"
      ];
      if (routes.includes(this.$route.name)) {
        this.calendarMini = getCalendarMini(this.$route.query.date, true);
      } else {
        this.calendarMini = null;
      }
    }
  },
  watch: {
    "$route.query.date": {
      immediate: true,
      handler() {
        this.fetchCalendar();
        this.today = formatISO(new Date());
      }
    },
    "$route.name": {
      immediate: true,
      handler() {
        this.fetchCalendar();
      }
    }
  }
};
</script>

<style>
table.calendar {
  letter-spacing: 1px;
  border-collapse: collapse;
  border-spacing: 0px;
  margin: 0px auto 0px auto;
}

table.calendar th {
  color: white;
  padding: 1px;
  border: 1px solid #bbbbbb;
  background: #aaaaaa;
}

table.calendar td {
  padding: 1px;
  border: 1px solid #bbbbbb;
  width: 18px;
}

.calendarHeader {
  color: white;
  padding: 1px;
  border: 1px solid #bbbbbb;
  background: #aaaaaa;
}

.calendarCell {
  padding: 1px;
  border: 1px solid #bbbbbb;
}

div.calendar {
  padding: 0px;
  background: white;
  position: absolute;
  min-width: 150px;
}

table.planner {
  border: 1px solid black;
  width: 100%;
}

table.planner tr {
  vertical-align: top;
}

table.planner th {
  border: 1px solid black;
  width: 14%;
}

table.planner td {
  border: 1px solid black;
  height: 11px;
  width: 18px;
  font-size: 0.8em;
}

.plannertoday {
  background: #ccccff;
}

.plannernextmonth {
  background: #aaaaaa;
}

.plannerweekend {
  background: #dddddd;
}

.plannerselected {
  background: #99dd99;
}

.plannerDismissed {
  text-decoration: line-through;
}
</style>
